import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var SubjectIds = /*#__PURE__*/function () {
  function SubjectIds() {
    _classCallCheck(this, SubjectIds);
  }

  _createClass(SubjectIds, null, [{
    key: "isValid",
    value: function isValid(value) {
      return value.length >= this.minLength && value.length <= this.maxLength;
    }
  }]);

  return SubjectIds;
}();

_defineProperty(SubjectIds, "maxLength", 3);

_defineProperty(SubjectIds, "minLength", 1);